import './HeaderWithDescription.scss';
import { ReactElement, ReactNode } from 'react';

interface IHeaderWithDescriptionProps {
  header: ReactNode;
  description?: ReactNode;
}

export const HeaderWithDescription = ({ header, description }: IHeaderWithDescriptionProps): ReactElement => (
  <div className='header-with-description'>
    <div className='header'>{header}</div>
    {description && <div className='description'>{description}</div>}
  </div>
);
